export const ru = {
    'change-success': 'Продукт успешно изменен',
    error: 'Произошла ошибка, повторите попытку'
};
